<!--
 * @Description: 常规工作/日常事务 申请
 * @Author: peifu
 * @Date: 2022-12-04 22:59:56
 * @LastEditors: PF
 * @LastEditTime: 2023-08-09 18:04:27
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">申请</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false);">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="shenqinghome">
        <el-row :gutter="20" class="top">
          <el-col :span="12">
            <el-card shadow="never" @click="daiChuLiClick">
              <div class="nei_rong">
                <p class="title">待处理</p>
                <div class="shu_liang">
                  <span>{{dclsl}}</span>
                  <span>全部</span>
                </div>
              </div>
              <div class="icon">
                <i class="iconfont icon-daichuli color2"></i>
              </div>
            </el-card>
          </el-col>
          <el-col :span="12">
            <el-card shadow="never" @click="yiTongGuoClick">
              <div class="nei_rong">
                <p class="title">已通过</p>
                <div class="shu_liang">
                  <span>{{yclsl}}</span>
                  <span>处理中</span>
                </div>
              </div>
              <div class="icon">
                <i class="iconfont icon-faqi color1"></i>
              </div>
            </el-card>
          </el-col>
          <!-- <el-col :span="8">
            <el-card shadow="never" style="height: calc(50% - 5px); margin-bottom: 10px;">
              <p>已处理</p>
              <div>
                <span>0</span>
                <span class="iconfont icon-youjiantou"></span>
              </div>
            </el-card>
            <el-card shadow="never" style="height: calc(50% - 5px);">
              <p>我收到的</p>
              <div>
                <span>0</span>
                <span class="iconfont icon-youjiantou"></span>
              </div>
            </el-card>
          </el-col> -->
        </el-row>
        <div class="sou_suo">
          <el-input v-model="bdmc" class="w-50 m-2" placeholder="请搜索要提交的表单" @change="initList">
            <template #prefix>
              <el-icon class="el-input__icon">
                <search />
              </el-icon>
            </template>
          </el-input>
        </div>
        <div class="nei_rong">
          <el-collapse v-model="activeNames">
            <el-collapse-item v-for="(item, index, key) in spglList" :key="key" :name="index">
              <template #title>
                <span>{{index}}</span>
                <span>{{item.length}}</span>
              </template>
              <ul class="nei_rong_ul">
                <li class="guan_li" v-for="(val, i) in item" :key="i">
                  <div class="guan_li_title" @click="faQiShenPiClick(val)">
                    <div :class="val.tbys" style="width: 50px; height: 50px; border: 1px solid #dcdfe6; font-size: 20px; border-radius: 10px; display: flex; justify-content: center; align-items: center;">
                      <i class="iconfont " :class="'icon-' + val.tb" style="font-size: 1em;"></i>
                    </div>
                    <span class="guan_li_name">{{val.bdmc}}</span>
                  </div>
                  <el-button type="primary" link class="cha_kan" @click="chaKanShuJuClick(val)">
                    <el-icon>
                      <PieChart />
                    </el-icon>
                  </el-button>
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </el-dialog>
    <edit v-if="isShenQingBianJiHome" v-model:isShenQingBianJiHome="isShenQingBianJiHome" :shenQingBianJiHomeObj="shenQingBianJiHomeObj" @ReturnData="ReturnData" />
    <daichuli v-if="isShenQingDaiChuLiHome" v-model:isShenQingDaiChuLiHome="isShenQingDaiChuLiHome" :shenQingDaiChuLiHomeObj="shenQingDaiChuLiHomeObj" />
    <yitongguo v-if="isShenQingYiTongGuoHome" v-model:isShenQingYiTongGuoHome="isShenQingYiTongGuoHome" :shenQingYiTongGuoHomeObj="shenQingYiTongGuoHomeObj" />
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { banGongShenPiFenZu, shenqingshenpinumber } from '@/api/home.js'
import { homeCloseWindow } from '@/api/common.js'
import edit from './edit.vue'
import daichuli from './daichuli.vue'
import yitongguo from './yitongguo.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const bdmc = ref()
const activeNames = ref([])
const spglList = ref([])
const dclsl = ref(0)
const yclsl = ref(0)

// 弹窗 开始
// 编辑
const isShenQingBianJiHome = ref(false)
const shenQingBianJiHomeObj = ref()
// 待处理
const isShenQingDaiChuLiHome = ref(false)
const shenQingDaiChuLiHomeObj = ref()
// 已通过
const isShenQingYiTongGuoHome = ref(false)
const shenQingYiTongGuoHomeObj = ref()
// 弹窗 结束

// 待处理
const daiChuLiClick = () => {
  isShenQingDaiChuLiHome.value = true
  shenQingDaiChuLiHomeObj.value = {
    title: '待处理'
  }
}
// 已通过
const yiTongGuoClick = () => {
  isShenQingYiTongGuoHome.value = true
  shenQingYiTongGuoHomeObj.value = {
    title: '已通过'
  }
}
// 发起审批
const faQiShenPiClick = (item) => {
  isShenQingBianJiHome.value = true
  shenQingBianJiHomeObj.value = {
    type: 1, // [1]发起审批 [2]查看数据
    id: item.id,
    bdmc: item.bdmc
  }
}
// 查看数据
const chaKanShuJuClick = (item) => {
  isShenQingBianJiHome.value = true
  shenQingBianJiHomeObj.value = {
    type: 2,
    id: item.id
  }
}
const ReturnData = () => {
  isShenQingBianJiHome.value = false
  emits('ReturnData')
  initList()
}

const initList = () => {
  const info = {
    bdmc: bdmc.value
  }
  banGongShenPiFenZu(info).then((res) => {
    spglList.value = res.data || []
    activeNames.value = []
    if (spglList.value) {
      for (const key in spglList.value) {
        activeNames.value.push(key)
      }
    }
  })
  // 头部标签数量
  shenqingshenpinumber().then((res) => {
    dclsl.value = res.data ? res.data.dclsl : 0
    yclsl.value = res.data ? res.data.yclsl : 0
  })
}
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'shenqing') {
      openList.value = true
      initList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
.shenqinghome {
  height: 100%;
  .top {
    height: 95px;
    :deep(.el-card__body) {
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      .nei_rong {
        .shu_liang {
          span:nth-child(1) {
            font-size: 2em;
            margin-right: 10px;
          }
          span:nth-child(2) {
            color: #909399;
          }
        }
      }
      .icon {
        display: flex;
        align-items: center;
        .iconfont:before {
          font-size: 40px;
        }
      }
    }
    .el-col {
      height: 100%;
    }
    .el-card {
      height: 100%;
      border: 0;
      background-color: #f7f7f7;
    }
    .el-card:hover {
      background-color: #e9e9eb;
    }
  }
  // 搜索
  .sou_suo {
    margin: 20px 0;
  }
  .nei_rong {
    .el-collapse-item__header {
      span:nth-child(1) {
        font-size: 16px;
        font-weight: bold;
        margin-right: 10px;
      }
      span:nth-child(2) {
        color: #909399;
      }
    }
    .nei_rong_ul {
      display: flex;
      flex-wrap: wrap;
      .guan_li {
        display: flex;
        align-items: center;
        width: 230px;
        padding: 10px;
        .guan_li_title {
          display: flex;
          width: calc(100% - 20px);
          align-items: center;
          .guan_li_name {
            margin-left: 10px;
            width: calc(100% - 70px);
          }
        }
        .cha_kan {
          font-size: 16px;
          position: absolute;
          right: 10px;
          display: none;
        }
      }
      .guan_li:hover {
        background-color: #e9e9eb;
        border-radius: 4px;
        :deep(.cha_kan) {
          display: block;
        }
      }
    }
  }
}
</style>
